"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
function setAttendeeBackgroundFilter(attendeeId, filterName) {
  return function (dispatch, getState) {
    var _getState = getState(),
      attendeeBackgroundFilter = _getState.attendeeBackgroundFilter;
    var currentAttendeeBackgroundFilter = attendeeBackgroundFilter[attendeeId];
    // Checking current filter, so we don't update if the value is the same.
    if (currentAttendeeBackgroundFilter === filterName) return;
    var action = {
      type: _types.BROADCAST_SET_ATTENDEE_BACKGROUND_FILTER,
      payload: {
        attendeeId: attendeeId,
        filterName: filterName
      }
    };
    dispatch(action);
  };
}
var _default = exports["default"] = setAttendeeBackgroundFilter;